var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title bgVip"},[_c('common-head',{attrs:{"is-return":true}}),_c('div',{staticClass:"shareFooter"},[_c('van-button',{staticClass:"footerBtn",on:{"click":_vm.gotoMember}},[_vm._v(_vm._s(_vm.$t('tba.toBeVIP')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }